import { render } from "./WarrantyOrderList.vue?vue&type=template&id=0507203e&scoped=true"
import script from "./WarrantyOrderList.vue?vue&type=script&lang=js"
export * from "./WarrantyOrderList.vue?vue&type=script&lang=js"

import "./WarrantyOrderList.vue?vue&type=style&index=0&id=0507203e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0507203e"]])

export default __exports__